export default __webpack_public_path__ + "static/slideshow-1-387d282287ea37b95c6398eaa2135a83.png";